import {msg} from "@/i18n/Message.ts";

/**
 * You can use this class to give user simple UI feedback with small flying badge
 * 
 */
class Feedback {
	// checkmark-circle-18-full, warning-18-bold, problem-performance

	/**
	 * @param {Element} element
	 * @return {Animation}
	 */
	static delete(element) {
		return element.animate([
			{ transform: 'scale(1)', opacity: 1, easing: "ease-out", offset: 0 },
			{ transform: 'scale(1.2)', opacity: 0.5, easing: "ease-in", offset: 0.5 },
			{ transform: 'scale(0)', opacity: 0, offset: 1 }
		], 600);
	}

	static ok(parentElement, text) {
		Feedback.report(parentElement, "checkmark-circle-18-full", text, "success");
	}

	static saved(parentElement) {
		Feedback.report(parentElement, "checkmark-circle-18-full", msg("report.logTable.saved"), "success");
	}

	static warning(parentElement, text) {
		Feedback.report(parentElement, "warning-18-bold", text, "warning");
	}

	static error(parentElement, text) {
		Feedback.report(parentElement, "problem-performance", text, "error");
	}

	static info(parentElement, text) {
		Feedback.report(parentElement, "info-18-full", text, "info");
	}

	/**
	 * Show feedback badge
	 * @param parentElement	element used to place feedback
	 * @param {string} icon anneca symbol
	 * @param {string} text short label
	 * @param {("success"|"warning"|"error"|"info")} type
	 */
	static report(parentElement, icon, text, type) {
		const badge = Feedback.createBadge(icon, text, type);
		document.body.append(badge);
		Feedback.showBadge(parentElement, badge);
	}

	static createBadge(icon, text, type) {
		const badge = document.createElement("div");
		badge.className = "feedback";
		switch (type) {
			case "success":
				badge.classList.add("success-feedback");
				break;
			case "warning":
				badge.classList.add("warning-feedback");
				break;
			case "error":
				badge.classList.add("error-feedback");
				break;
			case "info":
			default:
				badge.classList.add("info-feedback");
				break;
		}
		if (icon) {
			const ielm = document.createElement("f-icon");
			ielm.setAttribute("name", icon);
			badge.append(ielm);
		}
		if (text) {
			const telm = document.createElement("span");
			telm.append(document.createTextNode(text))
			badge.append(telm);
		}
		return badge;
	}

	static showBadge(parentElement, badge) {
		Feedback.positionBadge(parentElement, badge);
		badge.classList.add("visible-feedback");
		window.setTimeout(()=>{
			badge.classList.remove("visible-feedback");
			window.setTimeout(()=>{	// wait for CSS animation
				document.body.removeChild(badge);	// clean-up
			}, 500);
		}, 2000);
	}

	static positionBadge(parentElement, badge) {
		const parentRec = parentElement.getBoundingClientRect();
		const badgeRec = badge.getBoundingClientRect();
		badge.style.top = Math.max(parentRec.top + window.scrollY, window.scrollY) + "px";
		badge.style.left = Math.max((parentRec.left + parentRec.right) / 2 - badgeRec.width / 2 + window.scrollX, window.scrollX) + "px";
	}
}

export default Feedback;